import t from "@ext/localization/locale/translate";
import { ConfirmMenuItem } from "@ui-kit/ConfirmPopover";
import { Counter } from "@ui-kit/Counter";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTriggerButton } from "@ui-kit/Dropdown";
import { Icon } from "@ui-kit/Icon/Icon";
import type { ReactNode } from "react";
import { selectedRecordsDeleteBody } from "../DeleteSelectedConfirm";

interface SelectionDropdownProps {
	selectedCount: number;
	children: ReactNode;
	isLoading?: boolean;
}

export const SelectionDropdown = ({ selectedCount, children, isLoading }: SelectionDropdownProps) => {
	if (selectedCount === 0) return null;

	return (
		<DropdownMenu>
			<DropdownMenuTriggerButton className="pl-2.5 pr-2" disabled={isLoading} variant="outline">
				{t("enterprise.admin.selected")}
				<Counter className="tabular-nums p-0 min-w-0" variant="text">
					{selectedCount}
				</Counter>
				{isLoading ? <Icon className="animate-spin" icon="loader-circle" /> : <Icon icon="chevron-down" />}
			</DropdownMenuTriggerButton>
			<DropdownMenuContent align="start" className="font-sans font-normal">
				{children}
			</DropdownMenuContent>
		</DropdownMenu>
	);
};

export const DeleteDropdownItem = ({ onSelect, disabled }: { onSelect: () => void; disabled?: boolean }) => (
	<DropdownMenuItem disabled={disabled} onSelect={onSelect} type="danger">
		<Icon icon="trash" />
		{t("delete")}
	</DropdownMenuItem>
);

type BulkDeleteDropdownItemProps = {
	selectedCount: number;
	onConfirm: () => void;
	disabled?: boolean;
};

export const BulkDeleteDropdownItem = ({ selectedCount, onConfirm, disabled }: BulkDeleteDropdownItemProps) => (
	<ConfirmMenuItem
		confirm={{
			title: t("confirmation.delete.title"),
			description: selectedRecordsDeleteBody(selectedCount),
			confirmText: t("delete"),
			icon: "info",
			status: "error",
		}}
		disabled={disabled}
		onConfirm={onConfirm}
		type="danger"
	>
		<Icon icon="trash" />
		{t("delete")}
	</ConfirmMenuItem>
);

export const EditDropdownItem = ({ onSelect }: { onSelect: () => void }) => (
	<DropdownMenuItem onSelect={onSelect}>
		<Icon icon="pen" />
		{t("edit2")}
	</DropdownMenuItem>
);

export const AddToAllDropdownItem = ({ onSelect, disabled }: { onSelect: () => void; disabled?: boolean }) => (
	<DropdownMenuItem disabled={disabled} onSelect={onSelect}>
		<Icon icon="copy-plus" />
		{t("enterprise.admin.coverage.add-to-all")}
	</DropdownMenuItem>
);
